export default __webpack_public_path__ + "static/media/wShoes_2.b5c83ba3.bin";